import { Component } from 'react'
import GuestPicker from './../forms/GuestPicker'
import Typeahead from '../helpers/Typeahead'
import { FormattedMessage } from 'react-intl'
import FilterList from './../search/FilterList'
import TravelDatepicker from '../helpers/TravelDatepicker'

export default class FiltersDr extends Component {
  constructor(props) {
    super(props)

    this.filtersRef = React.createRef()
    this.state = {
      title: '',
      selectedGuests: {},
      monthes: props.monthes,
    }
  }

  handleDatesChange = ({ dateFrom, dateTo, duration }) => {
    this.props.updateParams({
      dateStart: dateFrom,
      dateTo,
      nights: duration,
    })
  }

  handleGuestsChange = ({ guests_split, divers, nonDivers, students, rooms }) => {
    if(!this.props.selectedFilters.dateStart && !this.props.selectedFilters.dateTo) {
      document.getElementById('datepicker').click()
    }
    this.props.updateParams({
      guests_split: divers || nonDivers || students ? guests_split : null,
      divers,
      nonDivers,
      students,
      rooms,
    })
  }

  handleViewChange = (view) => {
    this.props.updateParams({ view })
  }

  render() {
    return (
      <div ref={this.filtersRef} className={`filters ${this.props.selectedFilters.view === 'map' ? 'map-full-width' : ''}`}>
        { this.props.selectedFilters.view === 'map' ? (
          <button className='btn-red btn-go-to-list' onClick={() => this.handleViewChange('resorts')}>
            <i className='font-icons list-icon' />
            <FormattedMessage id='go_to_list_view' defaultMessage='Go to list view' />
          </button>)
          : (
            <div className='filter-list go-to-map' onClick={() => this.handleViewChange('map')}>
              <span>
                <i className='font-icons location-icon' />
                <FormattedMessage id='go_to_map' defaultMessage='Go to map' />
              </span>
            </div>
          )
        }

        <div className='main-filters' id='la-main-filters'>
          <p className='title'><FormattedMessage id='search' defaultMessage='Search' /></p>
          <div className='pt-selector results-type'>
            <a className='option active'>
              <i className='font-icons dive-resort-icon' />
              <span><FormattedMessage id='dive_resorts' defaultMessage='Dive resorts' /></span>
            </a>
            <a className='option' href={this.props.liveaboardDetails && this.props.liveaboardDetails.searchUrl}>
              <i className='font-icons liveaboard-icon' />
              <span><FormattedMessage id='liveaboards' defaultMessage='Liveaboards' /></span>
            </a>
          </div>
          <div className='search-block'>
            <label className='w_icon'>
              <i className='font-icons field-icon location-icon' />
              <Typeahead isWidget={this.props.isWidget} kind={20} inputValue={this.props.title} popupId='country-list-popup' />
            </label>
          </div>
          <div className={`form-group w_icon ${!this.props.selectedFilters.departure_date_month ? 'has-error' : ''}`}>
            <GuestPicker onSelect={this.handleGuestsChange} showIcon selectedGuests={this.state.selectedGuests} />
          </div>
          <div className={`form-group w_icon ${!this.props.selectedFilters.dateStart && this.props.selectedFilters.dateTo ? 'has-error' : ''}`}>
            <i className='font-icons field-icon location-icon' />
            <TravelDatepicker
              id='datepicker'
              callback={this.handleDatesChange}
              className='gray-input'
              minDuration={1}
              maxDuration={21}
              range
              datesInOneField
              minDurationForStudents={5}
              validateStudentsPackage
              students={this.props.selectedParams.students}
              dateFrom={this.props.selectedFilters.dateStart}
              dateTo={this.props.selectedFilters.dateTo}
              updateDuration
              guestsSplit={this.props.selectedParams.guests_split}
              placeholder={<FormattedMessage id='date' defaultMessage='Date' />} />
          </div>
          <button className='btn-red' id='search-btn' onClick={this.props.triggerApi}>
            <i className='font-icons find-icon' />
            <FormattedMessage id='search' defaultMessage='Search' />
          </button>
        </div>
        <FilterList
          updateParams={this.props.updateParams}
          selectedFilters={this.props.selectedFilters}
          items={this.props.items}
          diveResort
          expandedFilters={{
            price: true,
            stars: true,
            meal_plan: true,
            rating: true,
          }}
          clearSelectedFilters={this.props.clearSelectedFilters}
          filtersCount={this.props.filtersCount}
        />
        <div className='shadow-block'>
          <p className='title text-center'><FormattedMessage id='padi_traveler_reviews' defaultMessage='PADI travel reviews' /></p>
          <div className='trust-pilot text-center'>
            <div
              className='trustpilot-widget'
              data-locale={this.props.trustpilotLocale}
              data-template-id='53aa8912dec7e10d38f59f36'
              data-businessunit-id='55eeddbb0000ff00058313b3'
              data-style-height='130px' data-style-width='100%'
              data-theme='light'
              data-stars='5'
              data-schema-type='Organization'>
              <a href='https://www.trustpilot.com/review/travel.padi.com' target='_blank'>Trustpilot</a></div>
          </div>
        </div>
      </div>
    )
  }
}

// export default connect(
//   state => ({
//       pageLoader: state.pageLoader,
//   })
// )(FiltersLa)
